
import { useEffect, useState } from 'react';
import { ArrowRight, Rocket, Sparkles } from 'lucide-react';

const About = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [playAnimation, setPlayAnimation] = useState(false);
  
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    
    const element = document.getElementById('om-oss');
    if (element) observer.observe(element);
    
    return () => {
      if (element) observer.unobserve(element);
    };
  }, []);
  
  // En kreativ effekt som visar tre ord som roterar
  const creativeWords = ["berättelser", "varumärken", "idéer", "drömmar", "visioner", "koncept"];
  const [currentWord, setCurrentWord] = useState(0);
  
  useEffect(() => {
    const wordInterval = setInterval(() => {
      setCurrentWord((prev) => (prev + 1) % creativeWords.length);
      setPlayAnimation(true);
      setTimeout(() => setPlayAnimation(false), 500);
    }, 2000);
    
    return () => clearInterval(wordInterval);
  }, []);

  return (
    <section id="om-oss" className="py-24 bg-storystore-blue text-white overflow-hidden">
      <div className="container-section relative">
        {/* Kreativa element i bakgrunden */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute top-20 right-20 w-40 h-40 bg-storystore-red rounded-full opacity-5"></div>
          <div className="absolute bottom-40 left-10 w-60 h-60 bg-white rounded-full opacity-5 animate-pulse"></div>
          
          {/* Animerade kreativa linjer */}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-storystore-red to-transparent opacity-20"></div>
          <div className="absolute bottom-0 right-0 w-1 h-full bg-gradient-to-b from-transparent via-white to-transparent opacity-20"></div>
        </div>
        
        <div className="max-w-4xl mx-auto text-center relative">
          <div className={`transform transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}>
            <div className="inline-flex items-center gap-2 bg-white/10 text-white py-1 px-4 rounded-full text-sm font-medium mb-6 backdrop-blur-sm">
              <Rocket size={14} className="text-storystore-red" /> Lär känna oss
            </div>
            
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6">Om oss</h2>
          </div>
          
          <div className={`mb-8 transform transition-all duration-700 delay-100 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}>
            <img 
              src="/lovable-uploads/a416c1a4-be00-4547-a393-fd31cb9ca1a1.png" 
              alt="Story Store Logo" 
              className="w-32 mx-auto mb-6 animate-pulse"
            />
          </div>
          
          {/* Kreativ texteffekt */}
          <div className={`mb-10 py-6 bg-white/5 rounded-xl backdrop-blur-sm transform transition-all duration-700 delay-200 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}>
            <p className="text-xl md:text-2xl font-medium">
              Vi förverkligar{" "}
              <span className="relative inline-block">
                <span className={`absolute transition-all duration-500 ${playAnimation ? 'opacity-0 -translate-y-4' : 'opacity-100 translate-y-0'}`}>
                  <span className="text-storystore-red font-bold">{creativeWords[currentWord]}</span>
                </span>
                <span className="opacity-0">placeholdertextxx</span>
              </span>
            </p>
          </div>
          
          <div className={`space-y-6 text-lg transform transition-all duration-700 delay-300 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}>
            <p>
              Vi är Story Store – en kreativ mediebyrå baserad i Stockholm som brinner för att hjälpa 
              företag och influencers att synas på riktigt.
            </p>
            
            <p>
              Med passion för berättande, strategi och visuellt innehåll skapar vi kampanjer och 
              produktioner som berör och ger <span className="text-storystore-red font-semibold">konkreta resultat</span>.
            </p>
            
            <p>
              Oavsett om du är ett växande varumärke eller en driven influencer, är vi din partner i 
              varje steg – från idé till färdig produktion.
            </p>
          </div>
          
          <div className={`mt-12 flex justify-center space-x-4 transform transition-all duration-700 delay-400 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}>
            <a href="#kontakt" className="btn-primary inline-flex items-center gap-2 group">
              <span>Kontakta oss</span>
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </a>
            <a href="#tjanster" className="bg-transparent border-2 border-white hover:bg-white hover:text-storystore-blue text-white font-medium py-3 px-6 rounded transition-all duration-300 inline-flex items-center gap-2 group">
              <span>Utforska tjänster</span>
              <Sparkles size={18} className="group-hover:rotate-12 transition-transform" />
            </a>
          </div>
          
          {/* Kreativt element: cirkel med animerade partiklar */}
          <div className="absolute -bottom-20 -right-20 w-40 h-40 hidden md:block">
            <div className="absolute inset-0 rounded-full border-2 border-dashed border-white/20 animate-spin" style={{ animationDuration: '30s' }}></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
